import * as React from 'react'
import { ReactElement, useMemo } from 'react'
import { Currency } from '../../../config/i18nConfig'
import { Text } from '@fluentui/react-components'
import { formatNumber } from '../../../helpers/numberHelper'
import MoneyText from '../../Text/Currency/MoneyText'

type Props = {
    unit: string
    unitAmount: string
    unitFormat: string
    rate: string
    defaultUnitRate: string
    currency: Currency
}

export function UnitDescription(props: Props): ReactElement {
    const unitRate = useMemo(() => {
        return Number(props.rate) / Number(props.unitAmount)
    }, [props.unitAmount, props.rate])

    if ([Infinity, NaN].includes(unitRate)) {
        return (
            <Text block size={200} italic>
                Geen {props.unit} ingegeven
            </Text>
        )
    }

    return (
        <Text block size={200}>
            {formatNumber(props.unitAmount, props.unitFormat)} {props.unit}&nbsp;&times;&nbsp;
            <MoneyText
                amount={[Infinity, NaN].includes(unitRate) ? props.defaultUnitRate : unitRate}
                currency={props.currency}
                textProps={{ size: 200 }}
                inline
            />
        </Text>
    )
}
